export default __webpack_public_path__ + "cf92107f36f071f6384ccce628339e5f.ttf";